function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
export var overrideProps = function overrideProps(props) {
  var commonProps = props.commonProps,
    labelProps = props.labelProps,
    containerProps = props.containerProps,
    switchTextProps = props.switchTextProps,
    fieldWrapperProps = props.fieldWrapperProps,
    _props$iconProps = props.iconProps,
    iconProps = _props$iconProps === void 0 ? {} : _props$iconProps;

  // Label overrides
  var overriddenLabelProps = _objectSpread(_objectSpread({}, labelProps), {}, {
    required: labelProps.required || commonProps.required,
    isDisabled: labelProps.isDisabled || commonProps.isDisabled
  });

  // Container overrides
  var overriddenContainerProps = _objectSpread(_objectSpread({}, containerProps), {}, {
    hasError: containerProps.hasError || commonProps.hasError,
    isDisabled: containerProps.isDisabled || commonProps.isDisabled
  });

  // SwitchText overrides
  var overriddenSwitchTextProps = _objectSpread(_objectSpread({}, switchTextProps), {}, {
    hasError: switchTextProps.hasError || commonProps.hasError
  });

  // FieldWrapper overrides
  var overriddenFieldWrapperProps = _objectSpread({}, fieldWrapperProps);

  // iconProps overrides
  var overriddenIconProps = _objectSpread(_objectSpread({}, iconProps), {}, {
    isDisabled: iconProps.isDisabled || commonProps.isDisabled
  });
  return {
    overriddenLabelProps: overriddenLabelProps,
    overriddenContainerProps: overriddenContainerProps,
    overriddenSwitchTextProps: overriddenSwitchTextProps,
    overriddenFieldWrapperProps: overriddenFieldWrapperProps,
    overriddenIconProps: overriddenIconProps
  };
};